import React from "react";
import styles from "styles/genai/Edetail.module.scss";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";


export const PaginationEdt = ({
  currentPage = 1,
  totalPages ,
  onPageChange,
}) => {
  const MAX_VISIBLE_PAGES = 3;

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages && page !== currentPage) {
      onPageChange(page);
    }
  };

  const renderPageNumbers = () => {
    const pages = [];
    let leftSide = currentPage - Math.floor(MAX_VISIBLE_PAGES / 2);
    let rightSide = currentPage + Math.floor(MAX_VISIBLE_PAGES / 2);

    if (leftSide < 1) {
      rightSide += 1 - leftSide;
      leftSide = 1;
    }
    if (rightSide > totalPages) {
      leftSide -= rightSide - totalPages;
      rightSide = totalPages;
    }
    leftSide = Math.max(leftSide, 1);

    if (leftSide > 1) {
      pages.push(1);
      if (leftSide > 2) pages.push("...");
    }

    for (let i = leftSide; i <= rightSide; i++) pages.push(i);

    if (rightSide < totalPages) {
      if (rightSide < totalPages - 1) pages.push("...");
      pages.push(totalPages);
    }

    return pages.map((page, index) =>
      page === "..." ? (
        <span key={`ellipsis-${index}`} className={styles.ellipsis}>
          {page}
        </span>
      ) : (
        <button
          key={page}
          className={`${styles.pageButton} ${
            currentPage === page ? styles.activePage : ""
          }`}
          onClick={() => handlePageChange(page)}
        >
          {page}
        </button>
      )
    );
  };

  return (
    <div className={styles.paginateedetail}  style={{marginRight:"4px"}}>
      <span className={styles.arrow}>
        <ArrowBackIcon
          className={
            currentPage === 1 ? styles.disabledArrow : styles.activeArrow
          }
          onClick={() => handlePageChange(currentPage - 1)}
        />

        <button
          onClick={() => handlePageChange(currentPage - 1)}
          className={`${styles.paginationButton} ${
            currentPage === 1 ? styles.disabled : styles.active
          }`}
          disabled={currentPage === 1}
          style={{width:'63px'}}
        >
          
          Previous
        </button>
      </span>
          <span className={styles.renderNums}>

      {renderPageNumbers()}
          </span>

      <span className={styles.rightdirec} style={{marginLeft:"4px"}}>
        <button
          onClick={() => handlePageChange(currentPage + 1)}
          className={`${styles.paginationButton} ${
            currentPage === totalPages ? styles.disabled : styles.active
          }`}
          disabled={currentPage === totalPages}
          style={{width:'35px'}}
        >
          Next
         
        </button>
        <ArrowForwardIcon
          className={
            currentPage === totalPages
              ? styles.disabledArrow
              : styles.activeArrow
          }
          onClick={() => handlePageChange(currentPage + 1)}
        />
      </span>
    </div>
  );
};
